export function InvertColor(color) {
  return `#${(Number(`0x1${color}`) ^ 0xFFFFFF).toString(16).substr(0).toUpperCase()}`
}